import { useEffect, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import { AudioConferenceCall } from "../../../models";
import { SendOutboundDtmfRequestModel } from "../../../models/api/Call";

type Props = {
  show: boolean;
  handleShow: (value: boolean) => void;
  callSid?: string | null;
  selectedCall?: AudioConferenceCall | null;
  onSendOutboundDtmf: (value: SendOutboundDtmfRequestModel) => Promise<any>;
};

const keypadRows = [
  [
    { value: "1", label: "1" },
    { value: "2", label: "2" },
    { value: "3", label: "3" },
  ],
  [
    { value: "4", label: "4" },
    { value: "5", label: "5" },
    { value: "6", label: "6" },
  ],
  [
    { value: "7", label: "7" },
    { value: "8", label: "8" },
    { value: "9", label: "9" },
  ],
  [
    { value: "*", label: "*" },
    { value: "0", label: "0" },
    { value: "#", label: "#" },
  ],
];

export function ModalOutboundDtmfDial({
  show,
  handleShow,
  callSid,
  selectedCall,
  onSendOutboundDtmf,
}: Props) {
  const sendQueueRef = useRef(Promise.resolve());
  const [codeInput, setCodeInput] = useState("");
  const [legCallSidInput, setLegCallSidInput] = useState("");

  useEffect(() => {
    if (!show) {
      setCodeInput("");
      setLegCallSidInput("");
    }
  }, [show]);

  useEffect(() => {
    if (selectedCall?.callSid) {
      setLegCallSidInput(selectedCall.callSid);
    }
  }, [selectedCall?.callSid]);

  const appendKey = (digit: string) => {
    setCodeInput((prev) => prev + digit);

    if (!callSid || !legCallSidInput) {
      console.log("DTMF send skipped: missing identifier", {
        callSid,
        legCallSid: legCallSidInput,
      });
      return;
    }

    const currentCallSid = callSid;
    const currentLegCallSid = legCallSidInput;

    sendQueueRef.current = sendQueueRef.current.then(async () => {
      try {
        await onSendOutboundDtmf({
          callSid: currentCallSid,
          legCallSid: currentLegCallSid,
          digits: digit,
        });
      } catch (error) {
        console.error(error);
      }
    });
  };

  return (
    <Modal show={show} onHide={() => handleShow(false)} centered>
      <Modal.Header closeButton>
        <Modal.Title>Keypad</Modal.Title>
      </Modal.Header>

      <Modal.Body className="dialer-modal-body">
        <div className="dialer-modal">
          <div className="d-flex flex-column justify-content-center align-items-center dialer-content">
            <div className="d-flex flex-row">
              <div
                className="dialer-output shadow-sm"
                style={{
                  minWidth: codeInput.length > 25 ? codeInput.length * 10 + "px" : "250px",
                }}
              >
                <input
                  className="border form-control text-center"
                  value={codeInput}
                  readOnly
                  onKeyDown={(event) => event.preventDefault()}
                  onPaste={(event) => event.preventDefault()}
                  placeholder="Enter code"
                  style={{
                    minWidth: codeInput.length > 25 ? codeInput.length * 10 + "px" : "250px",
                  }}
                />
              </div>
            </div>

            <div className="key-row-wrapper keypad-grid mt-3">
              {keypadRows.map((row, rowIndex) => (
                <div className="key-row keypad-grid__row" key={`row-${rowIndex}`}>
                  {row.map((digit) => (
                    <button
                      key={digit.value}
                      value={digit.value}
                      className="btn btn-light shadow-sm ripple keypad-grid__button"
                      type="button"
                      onClick={() => appendKey(digit.value)}
                    >
                      <span className="keypad-grid__digit">{digit.label}</span>
                    </button>
                  ))}
                </div>
              ))}
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}
